const animationOffset = viewport().height * .8;

$('[data-animation]').each(function () {
    let $elem = $(this);

    // trigger animations visible on screen on page load immediately
    if ($elem.offset().top < (viewport().height + $(window).scrollTop())) {
        $elem.attr('data-animation-triggered', '');
    }

    window.addEventListener('scroll', function () {
        let scroll = window.scrollY;

        if (scroll > $elem.offset().top - animationOffset) {
            $elem.attr('data-animation-triggered', '');
        }
    });
});
